import React from 'react';
import { path } from 'ramda';
import { FormattedMessage, injectIntl } from 'react-intl';

import css from './styles.css';
import {
  firstPartDayHour,
  getDisplayDates,
  getHourFormattedBookingDate,
  moment, secondPartDayHour, thirdPartDayHour,
} from '../../util/dates';

const SectionSessionTimes = (props) => {
  const { publicData, intl } = props;
  const listingSessionTimes = {
    morningSlot: path(['morningSlot'], publicData),
    afternoonSlot: path(['afternoonSlot'], publicData),
    eveningSlot: path(['eveningSlot'], publicData),
  };
  const morningDate = moment().set({ hour: firstPartDayHour, minute: 0 });
  const {
    start: morningStart,
    end: morningEnd,
  } = getDisplayDates(true, null, { start: morningDate }, listingSessionTimes);
  const afternoonDate = moment().set({ hour: secondPartDayHour, minute: 0 });
  const {
    start: afternoonStart,
    end: afternoonEnd,
  } = getDisplayDates(true, null, { start: afternoonDate }, listingSessionTimes);
  const eveningDate = moment().set({ hour: thirdPartDayHour, minute: 0 });
  const {
    start: eveningStart,
    end: eveningEnd,
  } = getDisplayDates(true, null, { start: eveningDate }, listingSessionTimes);
  const fullDayDate = moment().set({ hour: firstPartDayHour, minute: 0 });
  const {
    start: fullDayStart,
    end: fullDayEnd,
  } = getDisplayDates(true, null, { start: fullDayDate }, listingSessionTimes, true);

  return (
    <div className={css.section}>
      <h2 className={css.sectionTitle}>
        <FormattedMessage id='Listing.goodTips' />
      </h2>
      <div className={css.container}>
        <div className={css.title}>
          <FormattedMessage id='Listing.sessionTimes' />
        </div>
        <div className={css.row}>
          <div className={css.capitalizedMessage}>
            <FormattedMessage id='Date.morning' />
          </div>
          <div>
            {getHourFormattedBookingDate(moment(morningStart), intl)} - {getHourFormattedBookingDate(moment(morningEnd), intl)}
          </div>
        </div>
        <div className={css.row}>
          <div className={css.capitalizedMessage}>
            <FormattedMessage id='Date.afternoon' />
          </div>
          <div>
            {getHourFormattedBookingDate(moment(afternoonStart), intl)} - {getHourFormattedBookingDate(moment(afternoonEnd), intl)}
          </div>
        </div>
        <div className={css.row}>
          <div className={css.capitalizedMessage}>
            <FormattedMessage id='Date.evening' />
          </div>
          <div>
            {getHourFormattedBookingDate(moment(eveningStart), intl)} - {getHourFormattedBookingDate(moment(eveningEnd), intl)}
          </div>
        </div>
        <div className={css.row}>
          <div className={css.capitalizedMessage}>
            <FormattedMessage id='ReservationsPage.fullday' />
          </div>
          <div>
            {getHourFormattedBookingDate(moment(fullDayStart), intl)} - {getHourFormattedBookingDate(moment(fullDayEnd), intl)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(SectionSessionTimes);



// WEBPACK FOOTER //
// ./src/components/SectionSessionTimes/index.js